import getCustomAxios from "../Helpers/customAxios";
import { camelizeKeys } from "humps";
import {
  RHEA_CMS_LOGIN_API_ENDPOINT,
  RHEA_CMS_VERSION_ENDPOINT,
  RHEA_CMS_REGISTER_API_ENDPOINT,
} from "../Constants/API";

import {
  setAccessTokenInLocalStorage,
  setRefreshTokenInLocalStorage,
} from "../Helpers/jwtUtility";

export function postLoginAPI(
  data,
  onSuccessCallback,
  onErrorCallback,
  onDoneCallback
) {
  const axios = getCustomAxios();
  axios
    .post(RHEA_CMS_LOGIN_API_ENDPOINT, data)
    .then((successResponse) => {
      const responseData = successResponse.data;

      let profile = camelizeKeys(responseData);

      profile.appImageURL = profile.appImageUrl;

      setAccessTokenInLocalStorage(profile.authToken);
      setRefreshTokenInLocalStorage(profile.refreshToken);

      onSuccessCallback(profile);
    })
    .catch((exception) => {
      let responseData = null;
      if (exception.response !== undefined && exception.response !== null) {
        if (
          exception.response.data !== undefined &&
          exception.response.data !== null
        ) {
          responseData = exception.response.data;
        } else {
          responseData = exception.response;
        }
      } else {
        responseData = exception;
      }
      let errors = camelizeKeys(responseData);

      let errorsStr = JSON.stringify(errors);
      if (errorsStr.includes("Incorrect email or password")) {
        errors = {
          auth: "Incorrect email or password",
        };
      }
console.log(errors)
      onErrorCallback(errors);
    })
    .finally(onDoneCallback);
}

export function getVersionAPI(
  onSuccessCallback,
  onErrorCallback,
  onDoneCallback
) {
  console.log("getVersionAPI: calling url:", RHEA_CMS_VERSION_ENDPOINT);
  console.log("getVersionAPI: calling method: get");
  const axios = getCustomAxios();
  axios
    .get(RHEA_CMS_VERSION_ENDPOINT)
    .then((successResponse) => {
      const responseData = successResponse.data;

      // Snake-case from API to camel-case for React.
      const data = camelizeKeys(responseData);

      // Return the callback data.
      onSuccessCallback(data);
    })
    .catch((exception) => {
      console.log("getVersionAPI: exception:", exception);
      let errors = camelizeKeys(exception);
      onErrorCallback(errors);
    })
    .then(onDoneCallback);
}
